// index.js

import Library from './Library';

export default Library;



// WEBPACK FOOTER //
// ./src/comps/Library/index.js